import React from 'react';

import {assertAndContinue} from 'Asserts';
import SigninChooseProviderPage from 'auth/SigninChooseProviderPage';
import BenchlingConfig from 'BenchlingConfig';
// @ts-expect-error
import GettingStartedView from 'components/GettingStartedView';
import EditorRoutes from 'foundation/EditorRoutes';
import notifications, {FOREVER_DURATION} from 'notifications';
import {ClientBannerModal, CLIENT_BANNER_MODAL_KEY} from 'onboarding/ClientBanner';
import DatadogUtil from 'performance/DatadogUtil';
import printerFriendlyViewHandler from 'routing/printerFriendlyViewHandler';
import {RouteBundle} from 'routing/RouteConstants';
import * as ModalContainer from 'ui-library/ModalContainer';
import {renderReactElement} from 'util/RootReactRender';

export const AuthRoutes: RouteBundle = {
  domain: 'auth',
  routes: [
    {urlPattern: 'signin', handler: signin, legacy: true},
    {urlPattern: 'signin/choose-provider', handler: signinChooseProvider, legacy: true},
    {urlPattern: 'signup', handler: signup, legacy: true},
    {urlPattern: 'access-policies', handler: EditorRoutes.dataPoliciesPage.bind(EditorRoutes), legacy: true},
    {
      urlPattern: 'data-policies/:policyId',
      handler: EditorRoutes.dataPolicyPage.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 's/:apiIdentifier/edit',
      handler: EditorRoutes.sharedFolderItemEditor.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: 's/:apiIdentifier/view', handler: printerFriendlyViewHandler, legacy: true},
  ],
};

function signin(): void {
  DatadogUtil.startRUMView('signin');
  _addHashToFormAction($('.signin-form'));
  if (BenchlingConfig.START_BANNER_CONFIG) {
    if ($('#has_acknowledged_banner').val() === 'true') {
      return;
    }
    ModalContainer.open(
      CLIENT_BANNER_MODAL_KEY,
      <ClientBannerModal
        bannerKey={BenchlingConfig.START_BANNER_CONFIG.bannerKey}
        showRequiredCheckbox={BenchlingConfig.START_BANNER_CONFIG.showRequiredCheckbox}
      />
    );
  }
}

function signinChooseProvider(): void {
  DatadogUtil.startRUMView('signin_choose_provider');
  if (!window.bootstrap || !window.bootstrap.signinProviders) {
    assertAndContinue(
      false,
      'Expected signinProviders to be specified for the signin/choose-provider endpoint.'
    );
    notifications.error('Page data is unexpectedly missing. Try refreshing the page.', {
      duration: FOREVER_DURATION,
    });
    return;
  }
  renderReactElement(
    <SigninChooseProviderPage
      providers={window.bootstrap.signinProviders}
      nextURL={window.bootstrap.nextURL}
    />
  );
}

function signup(): void {
  DatadogUtil.startRUMView('signup');
  _addHashToFormAction($('.signup-form'));
  new GettingStartedView({el: $('.sign-up')}).render();
  if (BenchlingConfig.START_BANNER_CONFIG) {
    if ($('#has_acknowledged_banner').val() === 'true') {
      return;
    }
    ModalContainer.open(
      CLIENT_BANNER_MODAL_KEY,
      <ClientBannerModal
        bannerKey={BenchlingConfig.START_BANNER_CONFIG.bannerKey}
        showRequiredCheckbox={BenchlingConfig.START_BANNER_CONFIG.showRequiredCheckbox}
      />
    );
  }
}

// helpers

function _addHashToFormAction($form: JQuery): void {
  $form.attr('action', $form.attr('action') + window.location.hash);
}
